import invert from 'lodash/invert';
import snakeCase from 'lodash/snakeCase';

import LayoutCommonNew from "../../visComponents/layoutCommonNew";

import {LayoutType, LayoutAbbreviation, METADATA} from "./constants";
import zIndexes from "./zIndex";

import Other from "./parts/other";
import NonVisualizerSubPart from "./subparts/nonVisualizerSubPart";
import DesignNavigationItem from "../../visComponents/designNavigationItem";
import Background from "./parts/background";
import {ShowerAccessories} from "./parts/showerAccessories";
import {Toilet} from "./parts/toilet";
import {WindowParent} from "./parts/windowParent";
import Floor from "./parts/floor";
import Walls from "./parts/walls";
import {Shower} from "./parts/shower";
import {Vanity} from "./parts/vanity";
import {ShowerTubCombo} from "./parts/showerTubCombo";
import Globals from "./parts/globals";
import {Bathtub} from "./parts/bathtub";
import {AVAILABLE_VISUALIZER_TYPES} from "../../../config";
import {Accessories} from "./parts/accessories";

export class Layout extends LayoutCommonNew {

  /**
   * @type {int}
   */
  defaultType = LayoutType.Layout1;
  type = this.defaultType;
  scene = "1";
  visualizerType = AVAILABLE_VISUALIZER_TYPES.bvLook;
  localStorageKey = "bvLookState";
  layersBinding = "BathroomV5";
  layoutNames = LayoutAbbreviation;
  layoutTypes = LayoutType;
  zIndexes = zIndexes.layouts;
  excludedPartIdsFromHover = ["background_bg", "walls_ceiling", "front_wall_crop", "left_wall_crop",
    "right_wall_crop", "shower_wall_mirror", "window_body", "shower_screen", "skirting_board"];
  checkMorePointsPartIds = ["vanity_faucet", "vanity_sink", "shower_fixture", "bathtub_fixture", "towel_bar",
    "robe_hook", "towel_ring", "soap_dish", "corner_shelf"];

  constructor(props) {
    super(props);
    this.parts[Background.id]     = new Background();
    this.parts[Walls.id] = new Walls();
    this.parts[Vanity.id]         = new Vanity();
    this.parts[Shower.id]         = new Shower();
    this.parts[ShowerTubCombo.id] = new ShowerTubCombo();
    this.parts[ShowerAccessories.id] = new ShowerAccessories();
    this.parts[Accessories.id]    = new Accessories();
    this.parts[Bathtub.id]        = new Bathtub();
    this.parts[Toilet.id]         = new Toilet();
    this.parts[Floor.id]          = new Floor();
    this.parts[WindowParent.id] = new WindowParent();
    // this.parts[Ceiling.id]        = new Ceiling();
    this.parts[Globals.id] = new Globals();
    this.parts[Other.id] = new Other();
    Object.values(this.parts).forEach(part => part.layout = this);
  }

  fixFeatureMetaData(dbFeature) {
    dbFeature.metaData.RoomLayout = dbFeature.metaData.RoomLayout.map((mValue) => {
      mValue = (mValue || "").replace("Look ", "").replace("Layout", "");
      if (+mValue >= 10) {
        if (document.kvConfig.userId === 140067) {
          mValue = (+mValue - 10) + ""
        } else {
          dbFeature.isFromAsRoom = true;
        }
      }
      if (!mValue.includes("Layout")) {
        mValue = "Layout" + mValue
      }
      return mValue
    });
    // ["ShowerSize", "SplitWallType"].forEach(metaName => { // splitWallType should not use 0 as all
    ["ShowerSize"].forEach(metaName => {
      if (Array.isArray(dbFeature.metaData[metaName])) {
        if (dbFeature.metaData[metaName].includes("0")) {
          dbFeature.metaData[metaName] = [METADATA.ALL]
        } else if (dbFeature.metaData[metaName].includes("30")) {
          dbFeature.metaData[metaName] = dbFeature.metaData[metaName].map(metaValue => {
            if (metaValue === "30") { // we have 30 and 36, but they should be the same. we decided to make all 36 as the shower body
              return "36"
            }
            return metaValue
          })
        }
      }
    });
    if (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"].length) {
      dbFeature.metaData.layerPosition = dbFeature.metaData["Side"][0]
    }
    Object.keys(dbFeature.metaData).forEach(key => {
      if (Array.isArray(dbFeature.metaData[key]) && (key !== "CropCoords")) {
        dbFeature.metaData[key] = dbFeature.metaData[key].flatMap(metaValue => {
          if (typeof metaValue === "string") {
            if (metaValue.includes(", ")) {
              return metaValue.split(", ")
            } else if (metaValue.includes(",")) {
              return metaValue.split(",")
            }
          }
          return metaValue
        })
      }
    });
    return dbFeature
  }

  getCurrentLayoutName(type = this.type) {
    return invert(LayoutType)[type];
  }

  getCurrentLayoutAbbreviation() {
    return LayoutAbbreviation[this.getCurrentLayoutName()]
  }

  addNonVisualizerSubPart(featureGroupName){
    const otherParent = this.parts[Other.id];
    const partId = snakeCase(featureGroupName);
    let relatedItem = otherParent.relatedItems.find(relatedItem => relatedItem.partId === partId);
    if (!relatedItem) {
      relatedItem = new NonVisualizerSubPart(true, partId, featureGroupName);
      relatedItem.getParent = () => otherParent;
      otherParent.relatedItems.push(relatedItem);
    }
    return new DesignNavigationItem(relatedItem.partName, relatedItem)
  }

}
